<template>
  <button
    class="mt-8 block inline-flex w-full items-center justify-center rounded-sm bg-gray-900 p-2 text-center font-normal uppercase tracking-[2px] text-gray-100"
  >
    <slot></slot>
  </button>
</template>
